import React from "react";
import { LatLngModel } from "../../defs/defs";

const useLocation = function () {
  const [location, setLocation] = React.useState<LatLngModel | null>(null);
  const [status, setStatus] = React.useState<string>("loading");
  React.useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          setLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          setStatus("success");
        },
        function (error) {
          setStatus("error");
        }
      );
    } else {
      setStatus("error");
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);
  return { location, status };
};
export default useLocation;
